var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 14,
    viewBox: "0 0 28 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.6792 7.55548C27.6788 7.5558 27.6786 7.55619 27.6782 7.55651L21.9631 13.244C21.535 13.6701 20.8425 13.6685 20.4163 13.2403C19.9902 12.8121 19.9918 12.1196 20.4199 11.6935L24.257 7.87501H1.09375C0.489671 7.87501 0 7.38534 0 6.78127C0 6.17719 0.489671 5.68752 1.09375 5.68752H24.257L20.42 1.86903C19.9919 1.4429 19.9902 0.750395 20.4163 0.322248C20.8425 -0.106009 21.5351 -0.107486 21.9632 0.318529L27.6782 6.00602C27.6786 6.00635 27.6788 6.00673 27.6792 6.00706C28.1076 6.4346 28.1062 7.12935 27.6792 7.55548Z",
    fill: "#3F3F3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightarrow);
export default __webpack_public_path__ + "static/media/rightarrow.0c5bef1e129a5920d51b031604229bbc.svg";
export { ForwardRef as ReactComponent };